<template>
    <div class="col col-12 text-center">
        <div class="row header_section">
            <div class="col col-12">
                <img src="@/assets/img/beer.png" class="rating_icon"/>
                <h2>Jak Vám chutnalo pivo?</h2>
                <span class="stage_counter">1/3</span>
            </div>
        </div>
        <div class="row justify-content-center rating_section">
            <div class="col col-4" v-on:click="selected = 1">
                <div class="rating_box" v-bind:class="{ rating_selected: selected == 1 }">
                    <img src="@/assets/img/poor.png"/>
                </div>
                <div v-show="selected == 1" class="rating_text">
                    nic moc
                </div>
            </div>
            <div class="col col-4" v-on:click="selected = 2">
                <div class="rating_box" v-bind:class="{ rating_selected: selected == 2 }">
                    <img src="@/assets/img/cool.png"/>
                </div>
                <div v-show="selected == 2" class="rating_text">
                    ušlo
                </div>
            </div>
            <div class="col col-4" v-on:click="selected = 3">
                <div class="rating_box" v-bind:class="{ rating_selected: selected == 3 }">
                    <img src="@/assets/img/love.png"/>
                </div>
                <div v-show="selected == 3" class="rating_text">
                    jako křen
                </div>
            </div>
        </div>
        <div class="row controls_section">
            <div class="col col-12">
                <b-button variant="primary" v-bind:class="{ disabled: selected == null }" to="/food">Ohodnotit</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                selected: null,
            }
        },
        name: 'ratingBeer',
    }
</script>

<style scoped lang="scss">
</style>
